import __vue_component__$2 from '../Spinner/Spinner.vue.js';
import __vue_component__ from './TableHeaderCell.vue.js';
import __vue_component__$1 from './TableRow.vue.js';

//

function withPxSuffix(value) {
  if (typeof value === 'number') return `${value}px`;
  return value;
}

var script = {
  components: {
    TableHeaderCell: __vue_component__,
    TableRow: __vue_component__$1,
    Spinner: __vue_component__$2
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    stickyHeader: {
      type: Boolean,
      default: false
    },
    stickyLeftColumn: {
      type: Boolean,
      default: false
    },
    stickyRightColumn: {
      type: Boolean,
      default: false
    },
    defaultColumnMinWidth: {
      type: [String, Number],
      default: 150
    },
    defaultColumnWidth: {
      type: [String, Number],
      default: '1fr'
    },
    infiniteScroll: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    sortedBy: {
      type: String,
      default: undefined
    },
    sortedDesc: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      observer: undefined,
      tableWidth: 0,
      activeRowId: undefined
    };
  },

  watch: {
    columns: {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.$refs.table.style.gridTemplateColumns = this.columns.map(column => {
              const width = column.width || this.defaultColumnWidth;
              const minWidth = column.minWidth || column.width || this.defaultColumnMinWidth;
              return `minmax(${withPxSuffix(minWidth)}, ${withPxSuffix(width)})`;
            }).join(' ');
            this.tableWidth = this.$refs.table.offsetWidth;
          }
        });
      },

      immediate: true
    }
  },

  async mounted() {
    this.createObserver();
  },

  methods: {
    headerSlotName(columnId) {
      return `header-${columnId}`;
    },

    onRowClick(row, event) {
      this.$emit('row-click', {
        row,
        event
      });
    },

    createObserver() {
      if (this.observer) {
        this.observer.unobserve(this.$refs['infinite-scroll-loader']);
      }

      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          this.tableBottomReached();
        }
      });
      this.observer.observe(this.$refs['infinite-scroll-loader']);
    },

    tableBottomReached() {
      this.$emit('table-bottom-reached', () => {
        this.createObserver();
      });
    },

    onSorted(column) {
      this.$emit('sorted', {
        id: column.id,
        desc: this.sortedBy === column.id ? !this.sortedDesc : false
      });
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Table/Table.vue_rollup-plugin-vue=script.js